'use client'

import * as React from 'react'
import { Label } from '@/components/ui/label'
import { filterSheetFieldLabelClassName } from '@/components/shared/filterSheetStyles'

interface FilterSheetFieldProps {
  label: string
  icon?: React.ReactNode
  children: React.ReactNode
}

export function FilterSheetField({ label, icon, children }: FilterSheetFieldProps) {
  return (
    <div className="flex flex-col gap-1.5">
      <Label className={`${filterSheetFieldLabelClassName} inline-flex items-center gap-1.5`}>
        {icon ? <span className="text-foreground/70 [&_svg]:h-3.5 [&_svg]:w-3.5">{icon}</span> : null}
        {label}
      </Label>
      {children}
    </div>
  )
}
